import { Component, Input, OnChanges } from '@angular/core';
import { NotaFiscalSintetica } from '../../../core/models/notas-fiscais/nota-fiscal-sintetica';

/** Listagem compartilhada de duplicatas: pedidos, oportunidades, CRM e promoções. */
@Component({
  selector: 'app-pedido-modal-notas-fiscais',
  standalone: false,
  templateUrl: './pedido-modal-notas-fiscais.component.html',
  styleUrls: ['./pedido-modal-notas-fiscais.component.scss']
})
export class PedidoModalNotasFiscaisComponent implements OnChanges {
  /* Uma linha por registro da NFE. */
  @Input() notasFiscais: NotaFiscalSintetica[] = [];
  valorTotal = 0;
  valoresNaoInformados = 0;

  ngOnChanges(): void {
    const notas = this.notasFiscais || [];
    this.valorTotal = notas.reduce((total, nota) => total + (nota.valor ?? 0), 0);
    this.valoresNaoInformados = notas.filter(nota => nota.valor == null).length;
  }
}
